/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { Diagnostics } from '@tivocorp/tivo-webapp-loggers';
import { ErrorTypes, LiveTvError } from '../../error';
import { Locale } from '../../locale/Locale';
import { LocaleKeys } from '../../locale/LocaleKeys';
import { Log } from '../../logging';


/*
    All the location related error from v1/inHomeLocation are mapped as a part of LiveTvLocationErrorMapper.
    Example: inBlacklist, out of home and out of region etc.
*/

export class LiveTvLocationErrorMapper {
    private static TAG: string = 'LiveTvLocationErrorMapper';

    private code: string;

    private description: string;

    private message: string;

    private title: string;

    private type: string;

    public constructor() {
        this.code = '';
        this.description = '';
        this.message = '';
        this.title = '';
        this.type = '';
    }

    private setLocationErrorProperties(errorCode: string) {
        switch (errorCode) {
            case ErrorTypes.LIVE_TV_IN_BLACKLIST_OSD_ERROR_C138:
                this.code = errorCode;
                this.description = Locale.getString(LocaleKeys.LIVE_TV_IN_BLACKLIST_OSD_MESSAGE);
                break;
            case ErrorTypes.LIVE_TV_LOCATION_RESTRICTION_OSD_ERROR_CODE_V418:
                this.code = errorCode;
                this.description = Locale.getString(
                    LocaleKeys.LIVE_TV_LOCATION_RESTRICTION_OSD_MESSAGE,
                );
                break;
            case ErrorTypes.LIVE_TV_OUT_OF_REGION_OSD_ERROR_V405:
                this.code = errorCode;
                this.description = Locale.getString(LocaleKeys.LIVE_TV_OUT_OF_REGION_OSD_MESSAGE);
                break;
            case ErrorTypes.LIVE_TV_OOH_OSD_ERROR_V404:
                this.code = errorCode;
                this.description = Locale.getString(LocaleKeys.LIVE_TV_OOH_OSD_MESSAGE);
                break;
            default:
        }
    }

    public getErrorByCode(errorCode: string): LiveTvError {
        Log.e(LiveTvLocationErrorMapper.TAG, 'location error code ', errorCode);
        Diagnostics.error(LiveTvLocationErrorMapper.TAG, 'location error code ', errorCode);
        this.setLocationErrorProperties(errorCode);
        return new LiveTvError(this.code, this.message, this.description, this.title, this.type);
    }
}
